(function () {
  if (window.trufitHeaderChatInitialized) return;
  window.trufitHeaderChatInitialized = true;

  const root = document.documentElement;
  let chat = null;
  let chatOpen = false;
  let initializing = false;
  let unreadCount = 0;
  let opener = null;

  function syncButtons() {
    const buttons = document.querySelectorAll('[data-gorgias-chat-trigger]');
    root.toggleAttribute('data-trufit-header-chat-ready', Boolean(chat && buttons.length));

    buttons.forEach(function (button) {
      button.hidden = !chat;
      button.setAttribute('aria-expanded', String(chatOpen));
      button.setAttribute('aria-label', unreadCount
        ? button.dataset.unreadLabel.replace('__TRUFIT_UNREAD_COUNT__', String(unreadCount))
        : button.dataset.chatLabel);

      const badge = button.querySelector('[data-gorgias-chat-unread]');
      badge.hidden = !unreadCount;
      badge.textContent = unreadCount > 99 ? '99+' : String(unreadCount);
    });
  }

  function onOpened() {
    chatOpen = true;
    syncButtons();
  }

  function onClosed() {
    chatOpen = false;
    syncButtons();
    if (opener?.isConnected && window.matchMedia('(max-width: 989px)').matches) {
      opener.focus({ preventScroll: true });
    }
    opener = null;
  }

  function onUnreadCount(count) {
    unreadCount = Math.max(0, Math.floor(Number(count) || 0));
    syncButtons();
  }

  const listeners = {
    'widget:opened': onOpened,
    'widget:closed': onClosed,
    unreadCount: onUnreadCount,
    destroy: disconnect,
  };

  function disconnect() {
    if (chat) {
      Object.entries(listeners).forEach(function ([event, listener]) {
        chat.off(event, listener);
      });
    }
    chat = null;
    chatOpen = false;
    unreadCount = 0;
    opener = null;
    syncButtons();
  }

  async function connect() {
    if (chat || initializing || !window.GorgiasChat) return;
    initializing = true;

    try {
      // The loading proxy is replaced by the real API when init resolves.
      await window.GorgiasChat.init();
      const api = window.GorgiasChat;
      if (!['open', 'close', 'isOpen', 'on', 'off'].every(function (method) {
        return typeof api?.[method] === 'function';
      })) return;

      chat = api;
      chatOpen = chat.isOpen();
      Object.entries(listeners).forEach(function ([event, listener]) {
        chat.on(event, listener);
      });
      syncButtons();
    } catch (_) {
      // Keep the native launcher if the app is blocked or fails to initialize.
      disconnect();
    } finally {
      initializing = false;
    }
  }

  document.addEventListener('click', function (event) {
    const button = event.target?.closest?.('[data-gorgias-chat-trigger]');
    if (!button || !chat || root.hasAttribute('data-trufit-purchase-master-open')) return;

    event.preventDefault();
    if (chat.isOpen()) {
      chat.close();
    } else {
      opener = button;
      chat.open();
    }
  });

  function onSectionChange() {
    queueMicrotask(syncButtons);
    connect();
  }

  window.addEventListener('gorgias-widget-loaded', connect);
  document.addEventListener('shopify:section:load', onSectionChange);
  document.addEventListener('shopify:section:unload', onSectionChange);
  connect();

  // Signed-in phones show chat as a floating bubble. Lift it above any bar fixed to the
  // bottom of the screen (sport "Buy Now" bar, product sticky bar, cart checkout bar).
  const phone = window.matchMedia('(max-width: 989px)');
  let liftFrame = 0;
  function measureLift() {
    liftFrame = 0;
    if (!phone.matches || !root.hasAttribute('data-trufit-logged-in')) {
      root.style.removeProperty('--trufit-chat-lift');
      return;
    }
    const height = window.innerHeight;
    let lift = 0;
    document.elementsFromPoint(window.innerWidth - 48, height - 24).forEach(function (el) {
      if (el.closest('#gorgias-chat-container')) return;
      for (let node = el; node && node !== document.body; node = node.parentElement) {
        if (getComputedStyle(node).position !== 'fixed') continue;
        const rect = node.getBoundingClientRect();
        if (rect.bottom >= height - 2 && rect.height < height * 0.5) lift = Math.max(lift, Math.ceil(height - rect.top));
        break;
      }
    });
    root.style.setProperty('--trufit-chat-lift', lift + 'px');
  }
  function queueLift() {
    if (!liftFrame) liftFrame = requestAnimationFrame(measureLift);
  }
  window.addEventListener('scroll', queueLift, { passive: true });
  window.addEventListener('resize', queueLift);
  setInterval(queueLift, 1500);
  queueLift();
})();
